export enum PriceAlertStatus {
    WATCH = 'WATCH',
    FIRED = 'FIRED',
    CONSUMED = 'CONSUMED',
    CANCELED = 'CANCELED'
}
